import type { ai as EN } from '../en/ai';

export const ai: Record<keyof typeof EN, string> = {
  'ai.composer.send': 'Senden',
  'ai.composer.stop': 'Stopp',
  'ai.composer.placeholder': 'Stell deinen Notizen eine Frage…',
  'ai.composer.rateLimited': 'Zu viele Anfragen. Versuch es in {seconds} Sekunden erneut.',
  'ai.composer.overBudget': 'Kontext übersteigt das Budget. Entferne eine Seite, um zu senden.',
  'ai.composer.hint': 'Enter zum Senden · Umschalt+Enter für eine neue Zeile',
  'ai.composer.promptLabel': 'Prompt',
  'ai.composer.promptDefault': 'Standard',
  'ai.composer.promptDefaultSuffix': ' · Standard',
  'ai.composer.modelLabel': 'Modell',

  'ai.chat.new': 'Neue Unterhaltung',
  'ai.chat.newWithPage': 'Neue Unterhaltung mit dieser Seite angehängt',
  'ai.chat.openFull': 'In voller Ansicht öffnen',
  'ai.chat.conversations': 'Unterhaltungen',
  'ai.chat.noConversations': 'Noch keine Unterhaltungen.',
  'ai.chat.delete': '{title} löschen',
  'ai.chat.pageCount.one': '{count} Seite',
  'ai.chat.pageCount.other': '{count} Seiten',
  'ai.chat.emptyTitle': 'Stell deinen Notizen eine Frage.',
  'ai.chat.emptyBody':
    'Häng Seiten als Kontext an, wähl einen Prompt, und Claude antwortet aus dem, was du geschrieben hast.',

  'ai.context.attach': 'Seite als Kontext anhängen…',
  'ai.context.attachLabel': 'Seite als Kontext anhängen',
  'ai.context.noMatch': 'Keine Seiten passen zu „{query}“.',
  'ai.context.pages': 'Seiten',
  'ai.context.heading': 'Kontext',
  'ai.context.attachPage': 'Seite anhängen',
  'ai.context.emptyTitle': 'Noch kein Kontext angehängt.',
  'ai.context.emptyBody': 'Häng eine Seite an und frag etwas.',
  'ai.context.attachThisPage': '„{title}“ anhängen',
  'ai.context.thisPage': 'diese Seite',
  'ai.context.untitled': 'Unbenannt',
  'ai.context.tokens': '{count} Tok.',
  'ai.context.detach': '{title} entfernen',
  'ai.context.page': 'Seite',
  'ai.context.includeDescendants': 'Unterseiten einbeziehen',
  'ai.context.expanded': ' · + {count} Seiten',
  'ai.context.imagesNotSent': 'Bilder werden nicht gesendet — Claude sieht nur ihren Alt-Text.',

  'ai.tokenMeter.context': 'Kontext',
  'ai.tokenMeter.ariaLabel': '{total} von {limit} Kontext-Tokens',
  'ai.tokenMeter.overBudget':
    'Kontext übersteigt das Budget — {total} von {limit} Tokens. Entferne eine Seite, um zu senden.',
  'ai.tokenMeter.warn':
    'Großer Kontext — jeder Zug liest ihn neu. Zwischengespeicherte Züge kosten etwa ein Zehntel, aber der erste kostet den vollen Preis.',

  'ai.thread.copy': 'Kopieren',
  'ai.thread.copied': 'Kopiert.',
  'ai.thread.copyFailed': 'Kopieren fehlgeschlagen.',
  'ai.thread.noAnswer': 'Es wurde keine Antwort erzeugt.',
  'ai.thread.stopped': 'Gestoppt.',
  'ai.thread.waitingForFirstToken': 'Warte auf das erste Token',
  'ai.thread.jumpToLatest': 'Zum neuesten springen',
  'ai.thread.inputTokens': 'Eingabe-Tokens',
  'ai.thread.outputTokens': 'Ausgabe-Tokens',
  'ai.thread.cachedTitle': 'aus dem Prompt-Cache gelesen',
  'ai.thread.cached': '{count} zwischengespeichert',

  'ai.prompts.settings': 'Einstellungen',
  'ai.prompts.title': 'Prompt-Bibliothek',
  'ai.prompts.name': 'Name',
  'ai.prompts.body': 'Text',
  'ai.prompts.defaultPrompt': 'Standard-Prompt',
  'ai.prompts.defaultPromptHint': '— bei einer neuen Unterhaltung vorausgewählt.',
  'ai.prompts.deletePrompt': 'Prompt löschen',
  'ai.prompts.deleteTitle': 'Den Prompt „{name}“ löschen?',
  'ai.prompts.deleteDescPre': 'Unterhaltungen, die ihn verwendet haben, werden ',
  'ai.prompts.deleteDescStrong': 'nicht',
  'ai.prompts.deleteDescPost':
    ' gelöscht — ihr Verlauf bleibt erhalten und sie greifen beim nächsten Zug auf den integrierten Prompt zurück.',
  'ai.prompts.namePlaceholder': 'Lore Keeper, Session Recap…',
  'ai.prompts.bodyPlaceholder': 'Du bist…',
  'ai.prompts.createPrompt': 'Prompt erstellen',
  'ai.prompts.default': 'Standard',
  'ai.prompts.newPrompt': 'Neuer Prompt',
  'ai.prompts.empty': 'Noch keine Prompts. Erstell einen, um loszulegen.',

  'ai.toast.conversationStartFailed': 'Die Unterhaltung konnte nicht gestartet werden.',
  'ai.toast.conversationUpdateFailed': 'Die Unterhaltung konnte nicht aktualisiert werden.',
  'ai.toast.conversationDeleteFailed': 'Die Unterhaltung konnte nicht gelöscht werden.',
  'ai.toast.promptSaveFailed': 'Der Prompt konnte nicht gespeichert werden.',
  'ai.toast.promptDeleteFailed': 'Der Prompt konnte nicht gelöscht werden.',
};
